













import Vue from 'vue';
import { mapActions, mapState } from 'vuex';

export default Vue.extend({
  computed: {
    ...mapState(['launcher']),

    url() {
      return this.launcher ? this.launcher.url : 'about:blank';
    },
  },

  methods: {
    ...mapActions(['reset']),
  },
});
